import { Plane, Star, Clock, MapPin, Shield, Users, Gem, Navigation } from 'lucide-react';
import { Vehicle, Service, RoutePath } from './types';

export const COMPANY_INFO = {
  address: "Chemin de praz-séchaud 32, 1010 Lausanne, Switzerland",
  phone: "+41 21 219 10 66",
  email: "contact@limohass.ch",
  instagram: "#",
  linkedin: "#"
};

export const VEHICLES: Vehicle[] = [
  {
    id: 'class-s',
    name: 'Mercedes-Benz Classe S',
    category: 'First',
    description: "Le summum du raffinement automobile. La Classe S définit le standard du transport VIP. Idéale pour les déplacements prestigieux nécessitant un calme absolu et un confort inégalé.",
    passengers: 3,
    luggage: 2,
    image: '/Limohass-2025-mercedes-s-class.webp',
    features: ['Intérieur Cuir', 'Climatisation', 'Bouteilles d\'eau', ]
  },
  {
    id: 'class-e',
    name: 'Mercedes-Benz Classe E',
    category: 'Business',
    description: "L'élégance fonctionnelle par excellence. La berline d'affaires idéale pour les transferts aéroportuaires. Un confort supérieur, une sécurité maximale et une discrétion absolue.",
    passengers: 3,
    luggage: 2,
    image: '/Limohass-2025-mercedes-e-class.webp',
    features: ['Intérieur Cuir', 'Climatisation', 'Prises de chargement', 'Vitres teintées', 'Bouteilles d\'eau',]
  },
  {
    id: 'class-v',
    name: 'Mercedes-Benz Classe V',
    category: 'Group',
    description: "Le van de luxe pour vos délégations et familles. Espace généreux et finitions haut de gamme pour voyager en groupe vers les stations de ski ou l'aéroport avec tous vos bagages.",
    passengers: 7,
    luggage: 7,
    image: '/Limohass-2025-mercedes-v-class.webp',
    features: ['Intérieur Cuir', 'Climatisation', 'Sièges Modulables', 'Volume de coffre XXL', 'Vitres teintées', 'Bouteilles d\'eau', ]
  }
];

export const NAV_LINKS = [
  { label: 'Accueil', path: RoutePath.HOME },
  { label: 'Flotte', path: RoutePath.FLEET },

  { label: 'Lausanne', path: RoutePath.LAUSANNE },
  { label: 'À Propos', path: RoutePath.ABOUT },
  { label: 'Contact', path: RoutePath.CONTACT },
];

export const DROPDOWN_SERVICES = [
  { label: 'Vue d\'ensemble', path: RoutePath.SERVICES, icon: Gem },
  { label: 'Transferts Aéroport', path: RoutePath.TRANSFERS, icon: Plane },
  { label: 'Mise à Disposition', path: RoutePath.SERVICES, icon: Clock },
];

export const SERVICES: Service[] = [
  {
    id: 'airport',
    title: 'Transferts Aéroport GVA',
    description: 'Votre liaison privilégiée entre Lausanne et Genève. Profitez d’un accueil personnalisé avec pancarte, d’une prise en charge complète de vos bagages.',
    icon: Plane
  },
  {
    id: 'disposal',
    title: 'Mise à Disposition',
    description: 'Bénéficiez d’un chauffeur privé à l’heure ou à la journée. Une solution flexible et prestigieuse pour vos rendez-vous d’affaires, vos sorties shopping ou vos découvertes touristiques entre Lausanne et Genève.',
    icon: Clock
  },
  {
    id: 'events',
    title: 'Célébrations & Mariages',
    description: 'Une organisation rigoureuse pour vos moments d’exception. Nous assurons la coordination des cortèges et le transport de vos invités avec élégance, incluant la décoration florale sur demande.',
    icon: Star
  },
  {
    id: 'ski',
    title: 'Transferts Stations de Ski',
    description: 'Rejoignez les Alpes en toute sérénité vers Courchevel, Gstaad, Verbier ou Zermatt. Nos véhicules Mercedes sont spécialement équipés pour la montagne, garantissant confort et sécurité jusqu’au pied des pistes.',
    icon: MapPin
  }
];